export function convertButtonType (val) {
  if (val === 'POST') {
    return '新規作成'
  } else if (val === 'PUT') {
    return '更新'
  } else {
    return ''
  }
}
